import { SpringOptions, useMotionValue, useMotionValueEvent, useSpring } from 'framer-motion';
import { useState, useEffect } from 'react';

export function useSmoothedValue(target: number, duration: number = 1000): number {
  const springConfig: SpringOptions = {
    bounce: 0,
    duration,
  };
  const raw = useMotionValue(target);
  const smoothed = useSpring(raw, springConfig);
  const [smoothNumber, setSmoothNumber] = useState(smoothed.get());
  useEffect(() => raw.set(target), [raw, target]);
  useMotionValueEvent(smoothed, 'change', setSmoothNumber);
  return smoothNumber;
}
